import React from 'react';

import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Row from 'react-bootstrap/Row';
import { Link } from 'react-router-dom';

import logo from '@src/img/logos/foremost-logo.svg';

const HeaderMenuTopNoData = () => (
    <Row id="header-mobile-menu-row" className="header-mobile-menu-row d-md-none">
        <Col>
            <Container fluid className="p-0">
                <Navbar collapseOnSelect className="p-0 justify-content-start shadow-sm" expanded={false} expand="lg">
                    <Navbar.Brand as={Link} to="/" className="pl-0 pl-sm-5 mr-0">
                        <img src={logo} className="nav-brand-img d-inline-block align-middle" alt="Foremost Insurance Group" />
                        <>
                            <span className="nav-brand-pipe align-middle" />
                            <span className="nav-brand-title align-middle">
                                Producer News Portal
                            </span>
                        </>
                    </Navbar.Brand>
                </Navbar>
            </Container>
        </Col>
    </Row>
);

export default React.memo(HeaderMenuTopNoData);
